import { css } from 'linaria';
import { styled } from 'linaria/react';

export const stickyCardWrapper = css`
  display: grid;
  row-gap: var(--space-200);
`;

export const fixedOuterContainer = css`
  gap: var(--space-100);
  display: flex;
  justify-content: space-between;
  left: 0;
  width: 100%;
  padding: 15px;
  bottom: 0;
  position: fixed;
  z-index: 3;
  background-color: var(--background-primary);
  border: solid 1px rgba(51, 51, 51, 0.1);
  border-left: 0;
  border-right: 0;
  @media (--to-desktop) {
    bottom: calc(var(--space-650) + env(safe-area-inset-bottom));
  }
`;

export const unfixedOuterContainer = css`
  height: auto;
`;

export const hidden = css`
  visibility: hidden;
  pointer-events: none;
`;

export const innerContainerFixed = css`
  display: flex !important;
  justify-content: space-between;
  height: var(--space-500);
  align-items: center;
`;

export const innerContainer = css`
  display: block;
  width: 100%;
`;

export const thumbImg = css`
  display: block;
  box-sizing: border-box;
  width: var(--space-500);
  height: var(--space-500);
  margin: auto 0;
`;

export const Basket = styled.div<{
  additionalMargin?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  margin-top: ${(props) => (props.additionalMargin ? 'auto' : '')};
  margin-bottom: ${(props) => (props.additionalMargin ? 'auto' : '16px')};
`;

export const ToCart = styled.div`
  flex: auto;
`;

export const SkeletonRows = styled.div`
  display: flex;
  flex-direction: column;
`;

export const bestPriceSkeleton = css`
  border-radius: var(--rounding-l);
  margin-top: var(--space-300);
  width: 126px;
  height: var(--space-250);
`;

export const priceSkeleton = css`
  border-radius: var(--rounding-l);
  margin-top: var(--space-100);
  width: 220px;
  height: var(--space-550);
`;

export const additionalPriceSkeleton = css`
  border-radius: var(--rounding-l);
  width: var(--space-1000);
  margin-top: var(--space-100);
  height: var(--space-250);
`;

export const basketSkeleton = css`
  border-radius: var(--rounding-l);
  width: 284px;
  margin-top: var(--space-200);
  height: var(--space-600);
`;
